import { Injectable } from '@angular/core';

import { DictionaryType } from '../models/types/dictionary.type';

/**
 * Service for cleaning up localStorage items that would
 * otherwise remain saved on the users device forever
 */
@Injectable({
    providedIn: 'root'
})
export class LocalStorageCleanupService {
    /**
     * Change this date to trigger a full localStorage cleanup
     */
    private readonly doCleanupAfter = Date.parse('2024-02-12');

    /**
     * add localStorage keys here that should never be removed in a cleanup
     */
    private readonly exceptions: string[] = ['sharelog.settings.userLanguage'];

    private readonly cleanupDateKey = 'lastCleanupDate';

    performCleanupIfRequired(): void {
        const dateStr = window.localStorage.getItem(this.cleanupDateKey);
        const date = Date.parse(dateStr ?? '');

        // check if cleanup required
        if (!Number.isNaN(date) && date > this.doCleanupAfter) {
            return;
        }

        // save exceptions
        const exceptionsCache: DictionaryType<string | null> = {};
        for (const key of this.exceptions) {
            exceptionsCache[key] = window.localStorage.getItem(key);
        }

        // perform cleanup
        window.localStorage.clear();
        window.localStorage.setItem(this.cleanupDateKey, new Date().toISOString());

        // load exceptions back into localStorage
        for (const key of this.exceptions) {
            const value = exceptionsCache[key];
            // eslint-disable-next-line no-null/no-null
            if (value != null) {
                window.localStorage.setItem(key, value);
            }
        }
    }
}
